<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="银行卡名称：">
            <el-input id="queryBankName" v-model="name" placeholder="请输入银行卡名称" clearable size="small" @input="handleQuery" />
          </el-form-item>
          <el-form-item label="借编码：">
            <el-input id="queryBorrowCode" v-model="borrowCode" placeholder="请输入借编码" clearable size="small" @input="handleQuery" />
          </el-form-item>
          
          <!-- <el-form-item>
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item> -->
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <div class="btn-box">
          <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">添加</el-button>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" @selection-change="selectionChange" @sort-change="sortChange">
        <el-table-column label="序号" prop="id" align="center" />
        <el-table-column label="银行卡名称" prop="bankName" align="center" />
        <el-table-column label="借编码 " prop="borrowCode" align="center">
          <template slot-scope="{row}">
            <span :style="{ color: getBorrowCodeCount(row.borrowCode) > 2 ? 'red' : '' }">
              {{ row.borrowCode }}
            </span>
          </template>
        </el-table-column>
        <el-table-column label="贷编码 " prop="loanCode" align="center" />
        <el-table-column label="城市公司" prop="cityName" align="center" />
        <el-table-column label="状态" prop="isEnable" align="center">
          <template slot-scope="{row}">
            <el-switch v-model="row.isEnable" active-value="1" inactive-value="0" @change="changeSwitch(row)"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="230">
          <template slot-scope="scope">
            <el-button type="text" @click="handleUpdate(scope)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <dubBank-add ref="dubBankAdd" @created="doQueryList({})" :rowItem="rowItem" />
  </div>
</template>

<script>
import dubBankAdd from './add'
import sysDataconstantApi from '@/api/config/sysDataconstant'
import Pagination from '@/components/Pagination'

function assignBankIds(list = []) {
  return list.map((item, index) => ({
    ...item,
    id: index + 1
  }))
}

export default {
  components: {
    Pagination,
    dubBankAdd
  },
  data() {
    return {
      list: [],
      total: 0,
      listLoading: true,
      query: {
        pageNo: 1,
        pageSize: 10,
      },
      selectItems: [],
      rowItem: null,
      name: '',
      borrowCode: ''
    }
  },
  created() {
    this.doQueryList({ pageNo: 1 })
  },
  methods: {
    handleFilter() {
      this.name = '';
      this.borrowCode = '';
      this.list = this.oldList
    },
    /**
     * 触发搜索操作
     */
    handleQuery() {
      let result = this.oldList || [];
      
      if (this.name) {
        result = result.filter(user =>
          user.bankName.includes(this.name)
        );
      }
      
      if (this.borrowCode) {
        result = result.filter(user =>
          user.borrowCode && user.borrowCode.includes(this.borrowCode)
        );
      }
      
      this.list = result;
    },
    /**
     * 执行列表查询
     */
    doQueryList() {
      this.listLoading = true
      return sysDataconstantApi.fetchCode({ code: 'lineUpMoneyBankType' })
        .then(({ data }) => {
          this.rowItem = data;
          this.list = data.content ? assignBankIds(JSON.parse(data.content)) : []
          this.oldList = JSON.parse(JSON.stringify(this.list))
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    changeSwitch(row) {
      let params = JSON.parse(JSON.stringify(this.rowItem))
      params.content = JSON.stringify(assignBankIds(this.list))
      sysDataconstantApi.update(params).then(() => {
        this.$common.showMsg('success', '操作成功')
        return this.doQueryList({ pageNo: 1 })
      })
    },
    /**
     * 打开新建表单
     */
    handleCreate() {
      this.$refs.dubBankAdd.handleCreate()
    },
    /**
     * 打开编辑表单
     */
    handleUpdate(scope) {
      this.$refs.dubBankAdd.handleUpdate(scope)
    },
    handleLog(row) {
      this.$router.push("/log/log?type=3&id=" + row.id);
    },
    /**
     * 获取借编码在列表中的出现次数
     */
    getBorrowCodeCount(borrowCode) {
      if (!borrowCode) return 0;
      return this.oldList ? this.oldList.filter(item => item.borrowCode === borrowCode).length : 0;
    }
  }
}
</script>
